import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";
import { useSessionStore } from "@/store/session";

const routes: RouteRecordRaw[] = [
    { path: "/", name: "home", redirect: { name: "orders" } },
    {
        path: "/authentication/login",
        name: "login",
        component: () => import("@/views/authentication/LoginView.vue"),
        meta: { guest: true },
    },
    { path: "/orders/tracking", name: "orders", component: () => import("@/views/orders/OrderTrackingView.vue") },
    { path: "/inventory", name: "inventory", component: () => import("@/views/inventory/InventoryView.vue") },
    { path: "/profile", name: "profile", component: () => import("@/views/profile/ProfileView.vue") },
    { path: "/manufacturers", name: "manufacturers", component: () => import("@/views/manufacturers/ManufacturersView.vue") },
    {
        path: "/manufacturers/:id",
        name: "manufacturer",
        component: () => import("@/views/manufacturers/ManufacturerView.vue"),
        props: true,
    },
    {
        path: "/admin",
        component: () => import("@/views/admin/AdminLayout.vue"),
        redirect: { name: "admin-users" },
        meta: { admin: true },
        children: [
            { path: "users", name: "admin-users", component: () => import("@/views/admin/AdminUsersView.vue") },
            { path: "users/:id", name: "admin-user", component: () => import("@/views/admin/AdminUserView.vue"), props: true },
            { path: "manufacturers", name: "admin-manufacturers", component: () => import("@/views/admin/AdminManufacturersView.vue") },
            { path: "manufacturers/:id", name: "admin-manufacturer", component: () => import("@/views/admin/AdminManufacturerView.vue"), props: true },
            { path: "accounts", name: "admin-accounts", component: () => import("@/views/admin/AdminAccountsView.vue") },
            { path: "accounts/:id", name: "admin-account", component: () => import("@/views/admin/AdminAccountView.vue"), props: true },
            { path: "orders", name: "admin-orders", component: () => import("@/views/admin/AdminOrdersView.vue") },
            { path: "carriers", name: "admin-carriers", component: () => import("@/views/admin/AdminCarriersView.vue") },
        ],
    },
    {
        path: "/public/tracking/:slug/:purchaseOrderNumber?",
        name: "tracker",
        component: () => import("@/views/public/TrackerView.vue"),
        props: true,
        meta: { guest: true, theme: "light" },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to) => {
    const session = useSessionStore();
    const guest = to.matched.some((r) => r.meta["guest"] === true);
    if (!guest && !session.authenticated) {
        return { name: "login", query: { redirect: to.fullPath } };
    }
    if (to.matched.some((r) => r.meta["admin"] === true) && !session.user?.isAdmin) {
        return { name: "home" };
    }
    return true;
});

// A route chunk that vanished after a deploy means this tab is on an old build, so load the target page on the current one
let staleBuild = false;
window.addEventListener("vite:preloadError", (event) => {
    event.preventDefault();
    staleBuild = true;
});
router.onError((_, to) => {
    if (staleBuild) window.location.assign(to.fullPath);
});

export default router;
